export const ERROR_DESCRIPTION_MAP: Map<number, string> = new Map([
  [
    1000,
    'ドライブ制御異常\n走行指令と実車速が一致しません。\n非常停止リモコンが作動していないか確認してください。\n車両のキースイッチがONになっているか確認してください。',
  ],
  [
    10000,
    'ドライブ制御警告\n走行指令と実車速が一致しません。\n車両が何かにぶつかったり、何かを引きずったりしていないか確認してください。床面の状態を確認してください。',
  ],
  [
    1001,
    '経路追従精度異常\n車両が経路から大きく離れています。\n正しい位置からスタートしたか、反射ポールが隠れたり脱落していたりしないか確認してください。',
  ],
  [
    10010,
    '経路追従警告\n車両が経路から離れています。\n正しい位置からスタートしたか、反射ポールが隠れたり脱落していたりしないか確認してください。',
  ],
  [
    1002,
    'ステア制御異常\nステア角指令と実ステア角が一致しません。\n非常停止リモコンが作動していないか確認してください。\nキースイッチを一度切ってから入れ直してください。\nエラーがクリアできない場合、手動モードに切り替えてハンドルを左右に動かしてから再度クリアしてください。',
  ],
  [
    1100,
    '長時間の障害物停止\n障害物を検出して停止したまま一定時間が経過しました。\n障害物を取り除き、安全を確認した後エラーをクリアしてください。',
  ],
  [
    1101,
    '長時間のタイヤガード反応\nタイヤガードが押されて停止したまま一定時間が経過しました。\nタイヤガードを押しているものを取り除き、安全を確認した後エラーをクリアしてください。',
  ],
  [
    1102,
    '自動走行中キーOFF\n自動走行中にキースイッチがOFFになりました。\n安全を確認した後キースイッチをONし、エラーをクリアしてください。',
  ],
  [
    1103,
    '自動走行中リモコン停止\n自動走行中にリモコンスイッチ操作で停止しました。\n安全を確認した後リモコンスイッチを解除し、エラーをクリアしてください。',
  ],
  [
    1104,
    'スリップ検知\n駆動輪の空転を検知しました。\n積載重量と床面の状態を確認してください。',
  ],
  [
    1105,
    '停止指令中のリフト動作\nリフトの停止指令中に爪が動いたことを検知しました。\nキースイッチを一度切ってから入れ直した後、エラーをクリアしてください。\nキースイッチをONすると爪が勝手に動く場合、使用を中止して点検を受けてください。',
  ],
  [
    1106,
    'リフト不動作\nリフトの上昇・下降指令中に爪が動きません。\nリフトコンタクタ、爪高さエンコーダのワイヤ、爪の周囲の障害物を確認してください。',
  ],
  [
    1700,
    'タスク失敗\nタスクが正常に完了できませんでした。\n車両の在荷センサ・タイヤガード・バンパースイッチが反応していないか確認してください。\n荷積み・荷降ろしが正確に完了したか確認し、していない場合は原因を取り除いてください。',
  ],
  [
    1701,
    '未初期化\n初期化をせずにタスクを送信しました。\n初期化を行ってください。',
  ],
  [
    1702,
    '初期化失敗\n初期化に指定したスロットが遠すぎるか、角度が合っていません。\n車両の位置・姿勢を確認してください。',
  ],
  [
    1710,
    'SRCスロットなし\n指定した始点スロットが存在しません。\n正しいマップを使っているか、指定が正しいか確認してください。',
  ],
  [
    1711,
    'DSTスロットなし\n指定した終点スロットが存在しません。\n正しいマップを使っているか、指定が正しいか確認してください。',
  ],
  [
    1712,
    'TRANSITスロットなし\n指定した経由スロットが存在しません。\n正しいマップを使っているか、指定が正しいか確認してください。',
  ],
  [
    1720,
    '経路検索失敗\n移動先までの経路が見つかりません。\nマップを確認してください。',
  ],
  [
    1721,
    '経路長不足\n移動先までの経路が短すぎます。\nマップを確認してください。',
  ],
  [
    1722,
    '経路生成失敗\n経路を生成できませんでした。\nマップを確認してください。',
  ],
  [
    1730,
    '空荷チェック失敗\n移動・荷積みタスク実行前に荷物が積まれた状態になっています。\n荷物を取り除いてください。または在荷センサを確認してください。',
  ],
  [
    1731,
    '荷積みチェック失敗\n荷降ろしタスク実行前に荷物が積まれていません。\n荷物の状態を確認してください。',
  ],
  [
    1732,
    '荷積み完了チェック失敗\n荷積みタスク後に在荷センサが反応しない、または爪の高さが適性でない状態です。',
  ],
  [
    1733,
    '荷降ろし完了チェック失敗\n荷降ろしタスク後に在荷センサが反応している、または爪の高さが適性でない状態です。',
  ],
  [1734, '高さチェック失敗\n爪の高さ制御に失敗しました。'],
  [
    1735,
    '荷降ろし前障害物チェック失敗\n荷降ろしすべき位置の床に障害物を発見しました。\n障害物を取り除いてください。',
  ],
  [
    1736,
    'パレット認識失敗\nパレット有無の判定に失敗しました。\nパレット置き場の状態を確認してください。',
  ],
  [1740, '在荷センサチェック失敗\n走行中に在荷センサの状態が変化しました。'],
  [
    1741,
    'タイヤガードチェック失敗\nタイヤガードスイッチの状態が正しくありません。',
  ],
  [
    1742,
    '在荷センサ状態不一致\n左右の在荷センサの状態が一致しません。\n荷物の状態を確認してください。\n荷物に問題がない場合は在荷センサの接続を確認してください。',
  ],
  [1799, 'その他のタスクエラー'],
  [
    2001,
    '位置推定異常\n位置推定精度が低下しています。\n反射ポールが隠れたり脱落していたりしないか確認してください。\n初期位置に移動した後、電源をOFF→ONしてください。',
  ],
  [
    3001,
    '認識後ルート生成失敗\n認識したパレットを取りに行くルートが生成できません。\nパレットの位置・傾きを修正し、再度パレット認識を実行してください。',
  ],
  [
    8001,
    'バンパースイッチ反応\nバンパーへの接触を検知しました。\nバンパーを押しているものを取り除き、安全を確認した後エラーをクリアしてください。',
  ],
  [
    8002,
    'バンパースイッチ接続異常(1)\nバンパースイッチ信号の接続が正しくありません。\nケーブルの接続を確認してください。',
  ],
  [
    8003,
    'バンパースイッチ接続異常(2)\nバンパースイッチGNDの接続が正しくありません。\nケーブルの接続を確認してください。',
  ],
  [
    8004,
    'EPS異常\nパワーステアリングのエラーが検出されました。\nキースイッチを一度切ってから入れ直した後、エラーをクリアしてください。',
  ],
  [
    8005,
    'IMU角速度異常\nIMUが異常な角速度を検出しました。\n機体に強い振動や衝撃が加わっていないか確認してください。',
  ],
  [
    9100,
    'CPU負荷過大(1)\n一部のプロセスがCPUを多く消費しています。\n起動直後の場合は通常問題ありません。\n走行中に発生する場合はサポートにご連絡ください。',
  ],
  [
    9101,
    'CPU負荷過大(2)\n全体のCPU負荷が高くなっています。\n起動直後の場合は通常問題ありません。\n走行中に発生する場合はサポートにご連絡ください。',
  ],
  [
    9102,
    'CPU過熱\nCPUの温度が高くなっています。\n走行を中断し、電源を落として冷却してください。\n何度も発生する場合はサポートにご連絡ください。',
  ],
  [
    9200,
    'ネットワーク異常\n内部のネットワーク通信が遅くなっています。通信状態を確認してください。',
  ],
  [
    9201,
    'ネットワーク切断\n内部のネットワークが切断されています。ケーブルの接続を確認してください。',
  ],
  [
    9300,
    '左フォーク先端センサーリセット\nセンサーがリセットしました。\n何度も発生する場合はサポートにご連絡ください。',
  ],
  [
    9310,
    '右フォーク先端センサーリセット\nセンサーがリセットしました。\n何度も発生する場合はサポートにご連絡ください。',
  ],
  [
    9501,
    'フォークリフト状態データ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9502,
    'トップLiDARデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9503,
    '左LiDARデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9504,
    '右LiDARデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9505,
    'リアLiDARデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9506,
    'フォーク高さセンサーデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9507,
    '左フォーク先端センサーデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9508,
    '右フォーク先端センサーデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9509,
    'IMUデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9510,
    'カメラデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9511,
    'DIOデバイスデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9512,
    'AIOデバイスデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9513,
    '車輪速センサーデータ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9514,
    '画像処理コンピュータ出力取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9515,
    '行動状態データ出力取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9520,
    '画像処理データ取得不能\n必要なデータが取得できません。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9601,
    'フォークリフト状態データ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9602,
    'トップLiDARデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9603,
    '左LiDARデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9604,
    '右LiDARデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9605,
    'リアLiDARデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9606,
    'フォーク高さセンサーデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9607,
    '左フォーク先端センサーデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9608,
    '右フォーク先端センサーデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9609,
    'IMUデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9610,
    'カメラデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9611,
    'DIOデバイスデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9612,
    'AIOデバイスデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9613,
    '車輪速センサーデータ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9614,
    '画像処理コンピュータ出力停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9615,
    '行動状態データ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9620,
    '画像処理データ停止\n必要なデータが停止しました。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9701,
    'フォークリフト状態データ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9702,
    'トップLiDARデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9703,
    '左LiDARデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9704,
    '右LiDARデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9705,
    'リアLiDARデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9706,
    'フォーク高さセンサーデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9707,
    '左フォーク先端センサーデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9708,
    '右フォーク先端センサーデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9709,
    'IMUデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9710,
    'カメラデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9711,
    'DIOデバイスデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9712,
    'AIOデバイスデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9713,
    '車輪速センサーデータ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9714,
    '画像処理コンピュータ出力遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9715,
    '行動状態データ出力遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9720,
    '画像処理データ遅延\nデータの出力周期が遅くなっています。\nケーブルや機器類の接続を確認してください。',
  ],
  [
    9801,
    'AIOデバイス指令遅延\n指令値の出力周期が遅くなっています。\nシステムを再起動してください。',
  ],
  [
    9901,
    'DIOデバイス指令遅延\n指令値の出力周期が遅くなっています。\nシステムを再起動してください。',
  ],
  [
    9902,
    'AIOドライバ実行遅延\nAIOドライバの実行周期が遅くなっています。\nシステムを再起動してください。',
  ],
  [
    9903,
    'エラーマネージャー実行遅延\nエラーマネージャーの実行周期が遅くなっています。\nシステムを再起動してください。',
  ],
  [
    9904,
    'データ周期モニター実行遅延\nデータ周期モニターの実行周期が遅くなっています。\nシステムを再起動してください。',
  ],
  [
    21001,
    'カメラ露出不足\nカメラ画像が暗すぎます。\n周囲の照明状態やカメラレンズの汚れを確認してください。',
  ],
  [
    21002,
    'カメラ露出過多\nカメラ画像が明るすぎます。\n直射日光や強い光源がカメラに当たっていないか確認してください。',
  ],
  [
    21003,
    'カメラ低コントラスト\nカメラ画像のコントラストが低すぎます。\n周囲の照明状態やカメラレンズの汚れ・曇りを確認してください。',
  ],
  [
    21004,
    'カメラ情報量不足\nカメラ画像から十分な特徴が得られません。\nカメラの視界が遮られていないか、レンズの汚れがないか確認してください。',
  ],
  [
    30001,
    'LCI BOX切断\nLCI BOXと通信できません。ネットワークの接続を確認してください。',
  ],
  [
    30101,
    '設備エラー\nPLCからエラー信号を受信したため停止しました。\n設備側の状態を確認し、復旧後にエラーをクリアしてください。',
  ],
  [
    30102,
    'PLC通信途絶\nPLCの生存信号が一定時間更新されていません。\nPLCとの通信・配線を確認し、復旧後にエラーをクリアしてください。',
  ],
])

/**
 * エラーコードから説明を取得
 * @param code エラーコード
 * @returns エラーの説明（未定義の場合はデフォルトメッセージ）
 */
export function getErrorDescription(code: number): string {
  return ERROR_DESCRIPTION_MAP.get(code) ?? `未定義のエラー (コード: ${code})`
}

/**
 * エラーの説明からタイトル（1行目）を取得
 * @param description エラーの説明
 * @returns タイトル部分
 */
export function getErrorTitle(description: string): string {
  const lines = description.split('\n')
  return lines[0]
}

/**
 * エラーの説明から詳細（2行目以降）を取得
 * @param description エラーの説明
 * @returns 詳細部分
 */
export function getErrorDetails(description: string): string {
  const lines = description.split('\n')
  return lines.slice(1).join('\n')
}

interface ErrorContext {
  errors?: { code: number; message?: string }[]
}

/**
 * メッセージ中のエラーコード（数字）を [code] title 形式に変換
 * 例: "エラー画面表示: 1002, 8004" → "エラー画面表示: [1002] ステア制御異常 [8004] EPS異常"
 * 未定義コードの場合は context.errors の message をフォールバックとして使用
 */
export function enrichErrorMessage(
  message: string,
  context?: ErrorContext | null
): string {
  return message.replace(
    /(?<=:\s*)([\d]{1,5}(?:\s*,\s*[\d]{1,5})*)/,
    (match) => {
      return match
        .split(/\s*,\s*/)
        .map((codeStr) => {
          const code = Number(codeStr)
          const description = getErrorDescription(code)
          if (!description.startsWith('未定義')) {
            const title = getErrorTitle(description)
            return `[${code}] ${title}`
          }
          // 未定義の場合は context.errors から message を取得
          const errorEntry = context?.errors?.find((e) => e.code === code)
          if (errorEntry?.message) {
            return `[${code}] ${errorEntry.message}`
          }
          return codeStr
        })
        .join(' ')
    }
  )
}
